@if (current()) {
  <!-- alg-select CVA reads/writes tag strings via ngModel; (change) emits the full SelectOption. -->
  <alg-select
    [ngModel]="current()"
    (ngModelChange)="current.set($event)"
    (change)="languageChanged($event)"
  >
    @for (lang of languages; track $index) {
      <alg-select-option [value]="lang">
        {{ lang.label }}
      </alg-select-option>
    }
  </alg-select>
}
